<template>
  <div :class="$b({ fullHeight })">
    <component
      :is="componentName"
      :in-modal="true"
      v-bind="$attrs"
    />
  </div>
</template>

<script>
import {
  SubscribeForm,
  CondensedLensGuide
} from '#components'

export default {
  name: 'DialogComponent',

  components: {
    SubscribeForm,
    CondensedLensGuide
  },

  inheritAttrs: false,

  props: {
    componentName: { type: String, default: '' },
    fullHeight: { type: Boolean, default: false },
  }
}
</script>

<style lang="postcss">
.DialogComponent--full-height {
  @apply h-full;
}
</style>